
// @ts-nocheck
import React, { useEffect } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { LANGUAGE, LANGUAGE_KEY } from 'constants/languageConstants';
import { useSupportedLanguagesContext } from 'containers/SupportedLanguagesContainer/SupportedLanguagesContext';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux';
import { UptimeTypography } from '@uptime/uptime-component';
import { useHistory } from 'react-router-dom';

type PopoverMenuOptionValue = string | number;
export interface IPopoverMenuOption<T = PopoverMenuOptionValue> {
  name: string | number;
  code: T;
  onClickFn: (option: IPopoverMenuOption<T>) => void;
  icon?: JSX.Element;
}


/** Enumeration of the supported languages **/
export type LanguageCode =
  | 'bg'
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'hu'
  | 'it'
  | 'ja'
  | 'ko'
  | 'pl'
  | 'pt'
  | 'pt_BR' // needed for knowledge article search
  | 'ru'
  | 'zh-Hans'
  | 'nl'
  | 'zh'
  | 'other';

/** Interface for the LanguageSelector component **/
interface LanguageSelectorProps {
  toTalLangActive: Array;
  onChange: (languageCode: LanguageCode) => void;
  languageCode: LanguageCode;
  otherLanguageKB: string;
  kind: 'app-content' | 'knowledge-articles-search';
}

interface Language {
  name: string;
  code: string;
}
interface LanguageOption extends Language {
  onClickFn: (selected: IPopoverMenuOption<LanguageCode>) => void;
}

/** Language selector for the get support page */
const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  toTalLangActive,
  onChange,
  languageCode,
  otherLanguageKB,
}) => {
  const history = useHistory();
  const { isOnBehalf } = useSelector(
    (state: RootState) => state.onBehalfReducer,
  );
  const { supportedLanguages } = useSupportedLanguagesContext();
  /** Sets search language */
  const onClickFn = (selected: IPopoverMenuOption<LanguageCode>): void => {
    if (selected.code === LANGUAGE.OTHER) {
      history.push(`/knowledge/detail/${otherLanguageKB}`);
      return;
    }
    localStorage.setItem(LANGUAGE_KEY, selected.code);
    onChange(selected.code);
  };

  const languageOptions: LanguageOption[] =
    !!supportedLanguages.active && supportedLanguages.data?.length > 0
      ? supportedLanguages.data
          .filter(language => !!language.active)
          .map(language => ({ ...language }))
      : [{ name: 'English', code: 'en' }];

  const language =
    languageOptions.find(item => item.code === languageCode) ||
    languageOptions[0];

  useEffect(() => {
    if (!!supportedLanguages.active && toTalLangActive.length === 1) {
      localStorage.setItem(LANGUAGE_KEY, toTalLangActive[0].code);
      onChange(toTalLangActive[0].code);
    }
  }, [toTalLangActive?.length]);

  const renderLanguageSelectorFunc = (
    isActive: boolean,
    totalLangActive: Array,
  ) => {
    if (!!isActive) {
      if (totalLangActive.length > 1) {
        return (
          <FormControl sx={{ minWidth: 120 }}>
            <Select
              disabled={isOnBehalf}
              sx={{ color: "text.secondary" }}
              onClick={(e)=>e.stopPropagation()}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              value={language.name}
              IconComponent={(props) => (<ExpandMore sx={{marginTop: '2px'}} {...props}/>)}
              MenuProps={{
                disablePortal: true,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left"
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    top: "305px",
                    height: "200px"
                  }
                }
              }}
            >
              {languageOptions.map((lang,index) => {
                return(
                  <MenuItem key={index} value={lang.name} onClick={()=> onClickFn(lang)}>{lang.name}</MenuItem>
                )
              })}
            </Select>
          </FormControl>
        );
      } else {
        return (
          <UptimeTypography>
            {!!language?.name ? language?.name : 'English'}
          </UptimeTypography>
        );
      }
    } else {
      return <></>;
    }
  };

  return renderLanguageSelectorFunc(supportedLanguages.active, toTalLangActive);
};

export default LanguageSelector;
